import { useEffect } from "react";

export default (onMountFunc) => {
  useEffect(() => {
    onMountFunc();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}